import { ref } from 'vue';

interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<void>;
  userChoice: Promise<{
    outcome: 'accepted' | 'dismissed';
    platform: string;
  }>;
}

const promptDeferred = ref<BeforeInstallPromptEvent | null>(null);

function init() {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    // @ts-expect-error
    promptDeferred.value = e;
  });
}

function getPromptDeferred() {
  return promptDeferred;
}

function clearPromptDeferred() {
  promptDeferred.value = null;
}

type ShowPromptArg = {
  handleAccept?: () => void;
  handleDismiss?: () => void;
};

async function showPrompt(arg: ShowPromptArg) {
  const deferred = getPromptDeferred();
  if (deferred.value) {
    deferred.value.prompt();

    const { outcome } = await deferred.value.userChoice;
    if (outcome === 'accepted') {
      arg.handleAccept?.();
    } else {
      arg.handleDismiss?.();
    }

    clearPromptDeferred();
  }
}

export default {
  init,
  getPromptDeferred,
  clearPromptDeferred,
  showPrompt,
};
